import type { ForwardedRef, ReactElement, RefAttributes } from 'react';
import { createLeafComponent, type SeparatorProps } from 'react-aria-components';
import cx from 'clsx';
import styles from './option-divider.module.css';

function renderOptionDivider(
  { className, slot, ...props }: SeparatorProps,
  ref: ForwardedRef<HTMLDivElement>
): ReactElement {
  return (
    <div
      {...props}
      className={cx(styles.separator, className)}
      ref={ref}
      role="none"
      slot={slot ?? undefined}
    />
  );
}

/**
 * Decorative divider between groups of options.
 *
 * Registered as a `separator` collection node so `ListBox` still treats it as a
 * non-focusable item, but rendered with `role="none"`: `role="separator"` is not
 * an allowed child of `role="listbox"` and fails `aria-required-children`.
 * `react-aria`'s own `Separator` forces that role and cannot be overridden.
 */
export const OptionDivider: (
  props: SeparatorProps & RefAttributes<HTMLDivElement>
) => ReactElement | null = createLeafComponent('separator', renderOptionDivider);
